import React from 'react';
import { Spin } from 'antd';

import { installProgressWords } from '../../utils/installProgressWords';

// What the install dialog shows while the API finishes a large install on its
// own (keepr-api KPR-1655): the step it is on, in the platform's words.
export default function InstallProgress({ run, joined = false }) {
	return (
		<div className="install-package__progress" role="status" aria-live="polite" data-testid="install-package-progress">
			<Spin size="small" />
			<div className="install-package__progress-text">
				<p className="install-package__progress-step">{installProgressWords(run, { joined })}</p>
				<p className="meta-line">A large package can take a minute. It keeps going if you close this, and its collection opens when it is ready.</p>
			</div>
		</div>
	);
}
